<template>
    <modal id="create-job-modal" size="xl">
        <template slot="title">Create Job</template>
        <template slot="body">
            <field-input v-model="form.title" label="Job Position"></field-input>
            <field-editor v-model="form.description" label="Description"></field-editor>
            <field-datetime v-model="form.publish_at" label="Publish Date"></field-datetime>
            <field-datetime v-model="form.expire_at" label="Expire Date"></field-datetime>

            <field-checkbox v-if="isadmin"
                            class="my-4"
                            v-model="form.with_payment"
                            label="Show Payment Form">
            </field-checkbox>

            <div v-show="form.with_payment">
                <div class="text-danger font-weight-bold" v-text="centsToMoneyFormat(this.amount)"></div>
                <payment-form class="my-3"
                              v-model="form.stripe_token"
                              @error="onError">
                </payment-form>
            </div>

        </template>
        <template slot="footer">
            <button type="button" class="btn btn-success" :disabled="isDisabled" @click="save()">Save</button>
        </template>

    </modal>
</template>
<script>
    export default {
        // props: ['isadmin', 'amount'],
        props:{
            amount:{
                type:Number
            },
            isadmin:{
                type:Boolean
            }
        },
        data() {
            return {
                form: new Form({
                    title: '',
                    description: `<p><strong>Description:<br /></strong>This position is a...</p>
                        <p><strong><br/></strong><strong>Posted Date: </strong>${moment().format('MMMM DD, YYYY')}<strong><br />Position Type: </strong>Full/Part Time<strong><br />Company Contact Name:</strong> John Doe<strong><br />Co phone number: </strong>(000) 000-0000<strong><br />Co Email: </strong><a href="mailto:email@email.com">email@email.com</a></p>
                        <p><strong><br/><a href="#">Click Here to Apply</a></strong></p>`,
                    publish_at: '',
                    expire_at: '',
                    enabled_at: this.isadmin ? moment().format() : null,
                    with_payment : true,
                    stripe_token:'',
                }),
                labs:''
                // with_payment:true,
                // stripe_token:'',
            }
        },
        mounted(){

        },
        computed: {
            isDisabled() {
                if (this.form.isSubmitted) return true;
                if (this.form.with_payment && !this.form.stripe_token) return true;
                return false;
            }
        },
        methods:{

            save() {
                this.form.post(`/api/jobs`).then(response => {
                    App.bus.$emit('refresh-jobs');
                    Alert.timer(response.message).then(() => {
                        this.refreshPage();
                    })
                    this.closeModal('create-job-modal');
                }).catch(errors => Alert.error(errors.first()));
            },
            onError() {
                this.form.isSubmitted = false;
                },
        },

    }
</script>
